import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MutationFunction } from 'react-apollo';
import { Button } from '@material-ui/core';
import { createStyles, withStyles, lighten, Theme, WithStyles } from '@material-ui/core/styles';

import { DeleteManualNotificationComponent } from 'api';
import { useNotify } from 'hooks';
import { Alert } from 'components';

interface IProps extends WithStyles<typeof styles> {
  onDelete: (mutation: MutationFunction) => void;
}

const styles = (theme: Theme) =>
  createStyles({
    deleteButton: {
      marginRight: theme.spacing(1),
      borderColor: theme.palette.error.main,
      '&:hover': {
        backgroundColor: lighten(theme.palette.error.main, 0.9),
      },
    },
  });

const Delete: FC<IProps> = ({ classes, onDelete }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const notify = useNotify();

  function handleNotification() {
    notify.info({ message: t('messages:deleteManualNotificationMessageSuccess') });
  }

  function renderConfirmation() {
    return (
      <DeleteManualNotificationComponent
        awaitRefetchQueries
        onError={notify.mutationError}
        onCompleted={handleNotification}>
        {mutationFn => (
          <Alert
            open={open}
            onConfirm={() => {
              onDelete(mutationFn);
              setOpen(false);
            }}
            onCancel={() => setOpen(false)}
            message={t('messages:deleteManualNotificationMessage')}
            confirm={t('common:delete')}
          />
        )}
      </DeleteManualNotificationComponent>
    );
  }

  return (
    <Fragment>
      <Button
        variant="outlined"
        size="small"
        className={classes.deleteButton}
        onClick={() => setOpen(true)}>
        {t('common:delete')}
      </Button>
      {renderConfirmation()}
    </Fragment>
  );
};

export default withStyles(styles)(Delete);
